import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';

// Pages
import Login from './pages/auth/Login';
import ResetPassword from './pages/auth/ResetPassword';
import Dashboard from './pages/dashboard/Dashboard';
import Users from './pages/users/Users';
import Roles from './pages/users/Roles';
import Customers from './pages/customers/Customers';
import Plans from './pages/plans/Plans';
import ActivationCodes from './pages/activation/ActivationCodes';
import Resellers from './pages/resellers/Resellers';
import Subscriptions from './pages/subscriptions/Subscriptions';
import Payments from './pages/payments/Payments';
import ActivityLogs from './pages/activitylogs/ActivityLogs';
import UsageManagement from './pages/usage/UsageManagement';
import Spinner from './components/common/Spinner';

const ProtectedRoute = ({ children, title }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center items-center min-h-screen"><Spinner size="lg" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustResetPassword) return <Navigate to="/reset-password" replace />;
  return <Layout title={title}>{children}</Layout>;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center items-center min-h-screen"><Spinner size="lg" /></div>;
  if (user && !user.mustResetPassword) return <Navigate to="/dashboard" replace />;
  return children;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/dashboard" element={<ProtectedRoute title="Dashboard"><Dashboard /></ProtectedRoute>} />
    <Route path="/users" element={<ProtectedRoute title="Internal User Management"><Users /></ProtectedRoute>} />
    <Route path="/roles" element={<ProtectedRoute title="Roles & Permissions"><Roles /></ProtectedRoute>} />
    <Route path="/customers" element={<ProtectedRoute title="Merchant Management"><Customers /></ProtectedRoute>} />
    <Route path="/plans" element={<ProtectedRoute title="Plan Management"><Plans /></ProtectedRoute>} />
    <Route path="/resellers" element={<ProtectedRoute title="Reseller Management"><Resellers /></ProtectedRoute>} />
    <Route path="/activation-codes" element={<ProtectedRoute title="Activation Codes"><ActivationCodes /></ProtectedRoute>} />
    <Route path="/subscriptions" element={<ProtectedRoute title="Subscription Management"><Subscriptions /></ProtectedRoute>} />
    <Route path="/payments" element={<ProtectedRoute title="Payment Management"><Payments /></ProtectedRoute>} />
    <Route path="/usage" element={<ProtectedRoute title="Usage & Overage Management"><UsageManagement /></ProtectedRoute>} />
    <Route path="/activity-logs" element={<ProtectedRoute title="Activity Logs"><ActivityLogs /></ProtectedRoute>} />
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="*" element={<Navigate to="/dashboard" replace />} />
  </Routes>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
